import React from "react";

import PageLayoutBase from "@/components/layouts/page/PageLayout";
import CampaignPause from "../components/CampaignPause";

const PageLayout = PageLayoutBase as React.ComponentType<any>;

const CampaignPausePage = () => {
  return (
    <div>
      <PageLayout className="pause-campaign-page">
        <CampaignPause />
      </PageLayout>
    </div>
  );
};

export default CampaignPausePage;
